import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import {LoginContext} from "./LoginContext";
import {useEffect} from "react";
import {parse} from "query-string";

export const LoginRedirect = () => {
   const {accessToken} = useParams<{ accessToken: string }>();
   const setLoginContext = useSetRecoilState(LoginContext)
   const navigate = useNavigate();

   const location = useLocation();
   let parsedQuery = parse(location.search);
   let preview = parsedQuery.preview === 'true';

   useEffect(() => {
      if (accessToken) {
         setLoginContext({
            accessToken,
            preview
         })
         if (location?.pathname) {
            const indexOf = location.pathname.indexOf(accessToken)
            if (indexOf > -1) {
               const goTo = location.pathname.substring(indexOf + (accessToken?.length || 0));
               if (goTo && goTo.length > 1) {
                  navigate(goTo);
                  return;
               }
            }
         }
      }
      navigate("/main", {
         replace: true
      })
   }, [accessToken, location.pathname, navigate, preview, setLoginContext])

   return <div/>
}